import * as React from "react";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const SlideOutHeight: React.FunctionComponent<{
  children: React.ReactNode;
  delay?: number;
  isVisible: boolean;
}> = ({ children, delay, isVisible }) => {
  const [overflow, setOverflow] = useState<"clip" | "visible">("clip");

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{
            height: {
              duration: 0.3,
              ease: [0.4, 0, 0.2, 1],
              delay: delay ?? 0,
            },
            opacity: {
              duration: 0.2,
              ease: "easeOut",
              delay: (delay ?? 0) + 0.1,
            },
          }}
          style={{ overflow }}
          onAnimationStart={() => setOverflow("clip")}
          onAnimationComplete={() => setOverflow("visible")}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
